










































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
declare var window: any;
@Component
export default class MobileAppBanner extends Vue {
  private showAppBanner: boolean = true;

  closeAppBanner() {
    this.showAppBanner = false;
  }
  get companyName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME');
  }
  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE')
  }

  get appstoreUrl() {
    let isAndroid = window.navigator.appVersion.indexOf('Android') !== -1;
    console.log('Android' + isAndroid);
    return isAndroid ? '' : window.WorkLLama.workllamaIosAppUrl;
  }

  get playstoreUrl() {
    let isIphone = window.navigator.appVersion.indexOf('iPhone') !== -1;
    console.log('iphone' + isIphone);
    return isIphone ? '' : window.WorkLLama.workllamaAndroidAppUrl;
  }

  get isAppBrowser() {
    return vxm.users.UserDeviceAppTkn || vxm.utility.UserDeviceToken;
  }
}
